import env from "configs";
import { adminApi} from "./api";
import {  USERS_TAG } from "./CONSTANTS";

export const usersApi = adminApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchUsers: builder.query<any[], void>({
      query: () => {
        // Get token from localStorage (adjust the key name if needed)
        const token = localStorage.getItem("accessToken") ?? localStorage.getItem("authToken") ?? localStorage.getItem("accessToken");

        console.log("=== USERS API REQUEST ===");
        console.log("Token:", token ? "Token found" : "No token found");
        console.log("URL:", `${env.API_BASE_URL}/users`);
        console.log("=== END REQUEST ===");

        return {
          url: `${env.API_BASE_URL}/users`,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`
          }
        };
      },
      transformResponse: (response: any) => {
        console.log("=== USERS API RESPONSE ===");
        console.log("Full Response:", response);
        console.log("Response Type:", typeof response);
        console.log("Is Array:", Array.isArray(response));

        if (response?.data) {
          console.log("Response.data:", response.data);
          console.log("Response.data Type:", typeof response.data);
          console.log("Response.data Is Array:", Array.isArray(response.data));
        }

        console.log("=== END SCHOOLS API RESPONSE ===");
        return response.DATA.users;
      },
      providesTags: [USERS_TAG]
    })
  })
});

export const { useFetchUsersQuery } = usersApi; 
